import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { mediaCategory, media } from "../app/schema";

export const GET_MEDIA_CATEGORIES = "GET_MEDIA_CATEGORIES";
export const GET_MEDIA_CATEGORY = "GET_MEDIA_CATEGORY";
export const POST_MEDIA_CATEGORIES = "POST_MEDIA_CATEGORIES";
export const PATCH_MEDIA_CATEGORIES = "PATCH_MEDIA_CATEGORIES";
export const DELETE_MEDIA_CATEGORY = "DELETE_MEDIA_CATEGORY";
export const GET_MEDIA_CATEGORY_MEDIAS = "GET_MEDIA_CATEGORY_MEDIAS";
export const POST_MEDIA_CATEGORY_MEDIAS = "POST_MEDIA_CATEGORY_MEDIAS";

export const SET_IS_ADD_MEDIA_CATEGORY_MODAL_VISIBLE = "SET_IS_ADD_MEDIA_CATEGORY_MODAL_VISIBLE";
export const SET_IS_REMOVE_MEDIA_CATEGORY_MODAL_VISIBLE = "SET_IS_REMOVE_MEDIA_CATEGORY_MODAL_VISIBLE";
export const SET_IS_EDIT_MEDIA_CATEGORY_MODAL_VISIBLE = "SET_IS_EDIT_MEDIA_CATEGORY_MODAL_VISIBLE";

// Validation
const validateForm = {
  createMediaCategory: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createMediaCategoryMedia: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const getMediaCategoriesGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/media-categories?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getMediaCategoryGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/media-categories/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postMediaCategories = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/media-categories`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchMediaCategory = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/media-categories/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteMediaCategories = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/media-categories/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getMediaCategoryMediasGet = (fetch, apiHost, accessToken, uid, meta) =>
  fetch(
    `${apiHost}/v1/media-categories/${uid}/medias?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const postMediaCategoryMedias = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/media-categories/${uid}/medias`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });
// Actions

export function getMediaCategories(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MEDIA_CATEGORIES],
    payload: {
      promise: getMediaCategoriesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { mediaCategories: arrayOf(mediaCategory) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getMediaCategory(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MEDIA_CATEGORY],
    payload: {
      promise: getMediaCategoryGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, mediaCategory);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateMediaCategory(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_MEDIA_CATEGORIES],
    payload: {
      promise: patchMediaCategory(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, mediaCategory);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function createMediaCategory(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_MEDIA_CATEGORIES],
    payload: {
      promise: validateForm
        ["createMediaCategory"](validate, data)
        .then(() =>
          postMediaCategories(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, mediaCategory);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeMediaCategory(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_MEDIA_CATEGORY],
    payload: {
      promise: deleteMediaCategories(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getMediaCategoryMedias(uid, meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MEDIA_CATEGORY_MEDIAS],
    payload: {
      promise: getMediaCategoryMediasGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        meta
      )
        .then(data => {
          return normalize(data, { medias: arrayOf(media) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function createMediaCategoryMedia(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_MEDIA_CATEGORY_MEDIAS],
    payload: {
      promise: validateForm
        ["createMediaCategoryMedia"](validate, data)
        .then(() =>
          postMediaCategoryMedias(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, media);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function setIsAddMediaCategoryModalVisible(value) {
  return {
    type: SET_IS_ADD_MEDIA_CATEGORY_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function setIsRemoveMediaCategoryModalVisible(value) {
  return {
    type: SET_IS_REMOVE_MEDIA_CATEGORY_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function setIsEditMediaCategoryModalVisible(value) {
  return {
    type: SET_IS_EDIT_MEDIA_CATEGORY_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

// Standard functions
export function validateFormFieldMediaCategories(form, name, value) {
  const feature = "mediaCategories";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/mediaCategories/actions.js